"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Messages = require("../../codegen/Messages");
var TRow_1 = require("./TRow");
var TCell_1 = require("./TCell");
var __1 = require("../..");
var util_1 = require("../../utils/util");
var controlledId = "row_" + util_1.uniqueGUID();
var ExpandableRow = /** @class */ (function (_super) {
    __extends(ExpandableRow, _super);
    function ExpandableRow(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleExpand = function () {
            _this.setState({
                isExpanding: !_this.state.isExpanding
            });
        };
        if (props.table.hasActions()) {
            console.error("OUI Table: Row actions and expansion are mutually exclusive, use one or the other.");
        }
        _this.state = {
            isExpanding: false
        };
        return _this;
    }
    ExpandableRow.prototype.render = function () {
        var isExpanding = this.state.isExpanding;
        var _a = this.props, row = _a.row, table = _a.table, renderExpansionContent = _a.renderExpansionContent;
        var checkboxCell = table.getBodyRowCheckboxCell(row);
        var bodyRowCells = table.getBodyRowCells(row);
        return (React.createElement(React.Fragment, null,
            React.createElement(TRow_1.default, { isActive: table.isRowSelected(row) },
                checkboxCell,
                bodyRowCells,
                React.createElement(TCell_1.default, { className: "oui-table__expandable-row__expansion-icon-cell" },
                    React.createElement(__1.Button, __assign({}, (isExpanding ? { "aria-controls": controlledId } : {}), { "aria-expanded": isExpanding, buttonIcon: isExpanding ? __1.Icon.ChevronUp : __1.Icon.ChevronDown, buttonStyle: __1.ButtonStyle.Default, label: isExpanding
                            ? Messages.Table.collapseRow()
                            : Messages.Table.expandRow(), onClick: this.toggleExpand })))),
            isExpanding && (React.createElement(TRow_1.default, { id: controlledId },
                React.createElement(TCell_1.default, { colSpan: checkboxCell ? bodyRowCells.length + 2 : bodyRowCells.length + 1, className: "oui-table__expandable-row__expansion-content" }, renderExpansionContent())))));
    };
    return ExpandableRow;
}(React.Component));
exports.default = ExpandableRow;
//# sourceMappingURL=ExpandableRow.js.map